/**
 * Entry point de la SPA React
 * Se ejecuta en el navegador del iframe/WebView
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Inicialización desde window.__INIT__ (pasado por el parent via postMessage o atributos)
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
